export function getStyledColor(color: string) : string {
    return getComputedStyle(document.documentElement).getPropertyValue(color);
}

